import { useEffect, useState } from 'react';

function readMatches(query) {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia(query).matches;
}

/**
 * 訂閱 `window.matchMedia(query)`；與 Tailwind 斷點對齊時請用同一數值
 *（例如 lg = `(min-width: 1024px)`）。
 */
export function useMatchMedia(query) {
  const [matches, setMatches] = useState(() => readMatches(query));

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }
    const mediaQuery = window.matchMedia(query);
    function handleChange(event) {
      setMatches(event.matches);
    }
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
}

/** Tailwind `lg` 斷點（1024px）。 */
export const LG_MIN_WIDTH_QUERY = '(min-width: 1024px)';

export function useIsDesktopLg() {
  return useMatchMedia(LG_MIN_WIDTH_QUERY);
}
